package app.spliddy.web.pages

import androidx.compose.runtime.Composable
import app.spliddy.web.Res
import app.spliddy.web.components.layouts.PageLayoutData
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import org.jetbrains.compose.web.dom.Text

@InitRoute
fun initPrivacyPolicyPagePage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData(Res.string.app_privacy_policy))
}

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun PrivacyPolicyPage() {
    Text("This will be the Privacy Policy page!")
}
